import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = "https://css-67zw.onrender.com";

export default function Auth() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);

    try {
      const url = isSignup
        ? `${API}/api/auth/signup`
        : `${API}/api/auth/login`;

      const res = await axios.post(
        url,
        { email, password },
        { withCredentials: true }
      );

      // 🔥 Save user globally
      login(res.data.user);

      // 🔥 ADMIN vs USER redirect
      if (res.data.user?.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/dashboard");
      }

    } catch (err) {
      console.error(err);
      setMsg(err?.response?.data?.message || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h2>{isSignup ? "Signup" : "Login"}</h2>

      <form onSubmit={submit}>
        <input
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button className="btn" disabled={loading}>
          {loading ? "Please wait..." : isSignup ? "Signup" : "Login"}
        </button>
      </form>

      <button onClick={() => setIsSignup(!isSignup)}>
        Switch to {isSignup ? "Login" : "Signup"}
      </button>

      {msg && <p style={{ color: "red" }}>{msg}</p>}
    </div>
  );
}
